import { useNotif } from '@/common/notif/NotifContext';
import { NotifMenu } from '@/common/notif/NotifMenu';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useState } from 'react';
import { SideNavButton } from './SideNavButton';

export const NotifButton = () => {
  const { notifCount } = useNotif();

  const [anchorEl, setAnchorEl] = useState(null);

  // When the ProfileButton is clicked, set the anchor element
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close the ProfileMenu by clearing the anchor
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <SideNavButton onClick={handleClick} tooltip="Notifications" badgeCount={notifCount} icon={fas.faBell} />
      <NotifMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} />
    </>
  );
};
